<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="tagId" v-if="form.tagId">
          {{form.tagId}}
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span v-if="form.level == 1">建议尺寸：750px * 350px</span>
          <span v-if="form.level == 2 || form.level == 3">
            建议尺寸：64px * 64px
          </span>
        </el-form-item>
        <el-form-item label="级别">
          <el-input-number
            v-model.number="form.level"
            :min="1"
            placeholder="级别"
            @change="levelChange"
          />
        </el-form-item>
        <el-form-item label="上级标签" prop="parentTagId">
          <el-select
            v-model="form.parentTagId"
            placeholder="请选择上级标签"
            class="fix-width"
            clearable
            :disabled="form.level == 1"
          >
            <el-option
              v-for="item in parentIdList"
              :key="item.tagId"
              :label="item.basic.title"
              :value="item.tagId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自定义跳转链接" prop="url">
          <el-input
            v-model.trim="form.url"
            class="fix-width"
            placeholder="请输入自定义跳转链接"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createTag, updateTag, findTagAll } from '@/api/mediaLibrary'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'MediaTagEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      parentIdList: [],
      form: {
        tagId: '',
        title: '',
        level: 1,
        icon: '',
        url: '',
        parentTagId: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        icon: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图标'))
              } else {
                callback()
              }
            },
          },
        ],
        parentTagId: [
          {
            // required: true,
            validator: (rule, value, callback) => {
              if (value == '' && this.form.level != 1) {
                callback(new Error('请选择上级ID'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    //获取标签列表
    async findTagAll(level) {
      const res = await findTagAll({ level })
      if (!res) return
      this.parentIdList = res
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改标签'
        this.form = Object.assign(this.form, row.basic)
        this.form.tagId = row.tagId
        const level = row.basic.level
        if (level !== 1) {
          this.findTagAll(level - 1)
        }
        if (level == 3) {
          this.rules.icon = []
        } else {
          this.rules.icon = [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value.length == 0) {
                  callback(new Error('请上传图标'))
                } else {
                  callback()
                }
              },
            },
          ]
        }
      } else {
        this.title = '新增标签'
        this.rules.icon = [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value.length == 0) {
                  callback(new Error('请上传图标'))
                } else {
                  callback()
                }
              },
            },
          ]
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    //level发生改变的时候
    levelChange(num) {
      if (num === 1) {
        //清空
        this.form.parentTagId = ''
        this.parentIdList = []
        return
      }
      //获取前一级tagId
      this.findTagAll(num - 1)
      //动态添加图片是否必传校验
      if (num == 1 || num == 2) {
        this.rules.icon = [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图标'))
              } else {
                callback()
              }
            },
          },
        ]
      } else {
        this.rules.icon = []
      }
    },
    // 图片
    image_remove(file, fileList) {
      this.form.icon = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.icon = `${QNHost}/${res.hash}`
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const tagId = this.form.tagId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${tagId ? '修改' : '新增'}标签吗`,
            null,
            async () => {
              tagId ? await updateTag(data) : await createTag(data)
              this.$baseMessage(
                `${tagId ? '修改' : '新增'}标签成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
</style>
